import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import type { DropdownOption } from 'ui-components/components/dropdown/dropdown-types';
import { GuidService } from 'ui-components/services/guid-service';

import Global from '../../../../../../store/global-selectors';
import type { WorkflowActionInputProps } from '../../../registries/registry-types';
import { messages } from '../messages';

const getOptionLabel = (option: DropdownOption) => option.name as string;
const getOptionValue = (option: DropdownOption) => String(option.shipFromId);

export const WarehouseDropdown: React.FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => {
  const intl = useIntl();
  const id = useMemo(() => GuidService.newGuid(), []);
  const shipFroms = useSelector(Global.selectSellerShipFroms);

  const handleSelect = useCallback(
    (value: string) => {
      onUpdate({ intParameter: value ? Number(value) : null });
    },
    [onUpdate],
  );

  return (
    <SearchableDropdownField
      className={className}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      id={id}
      onItemSelected={handleSelect}
      options={shipFroms}
      placeholder={intl.formatMessage(messages.warehouseDropdownPlaceholder)}
      selectedItemValue={draft.intParameter !== null ? String(draft.intParameter) : undefined}
    />
  );
};
